import { ReactComponent as UndoIcon } from './icons/undo.svg';
import { ReactComponent as RedoIcon } from './icons/redo.svg';
import { useInjection } from 'inversify-react';
import { TYPES } from '@/engine/ioc';

import { observer } from 'mobx-react';
import { type UndoRedoButtonsController } from './UndoRedoButtons.controller';
import { ButtonWrapper } from '../ButtonWrapper';
import { IconLabel } from '../IconLabel';
import { SvgIconButton } from '@/components/common/SvgIconButton';
import { Tooltip } from '@mui/material';

export const UndoRedoButtons: React.FC = observer(() => {
  const controller = useInjection<UndoRedoButtonsController>(TYPES.UndoRedoButtonsController);
  return (
    <>
      <ButtonWrapper disabled={!controller.canUndo}>
        <Tooltip title={controller.undoTooltip} placement="bottom">
          <SvgIconButton
            size="small"
            data-testid={'UndoBtn'}
            $isActive={false}
            component={UndoIcon}
            onClick={(): void => controller.undo()}
          />
        </Tooltip>
        <IconLabel style={{ gridArea: 'label' }}>Undo</IconLabel>
      </ButtonWrapper>
      <ButtonWrapper disabled={!controller.canRedo}>
        <Tooltip title={controller.redoTooltip} placement="bottom">
          <SvgIconButton
            size="small"
            data-testid={'RedoBtn'}
            $isActive={false}
            component={RedoIcon}
            onClick={(): void => controller.redo()}
          />
        </Tooltip>
        <IconLabel style={{ gridArea: 'label' }}>Redo</IconLabel>
      </ButtonWrapper>
    </>
  );
});
